import React from 'react';
import '../styles/GlobalErrorOverlay.css';

const GlobalErrorOverlay = ({ errorStatus, onClear, onNavigate }) => {
  if (!errorStatus) return null;

  const isApiKeyError = errorStatus === '400' || errorStatus === '403';
  const isQuotaError = errorStatus === '429';

  let title = "An Error Occurred";
  let message = "Something went wrong with the AI service. Please try again later.";
  let buttonText = "Dismiss";
  let action = onClear;

  if (isApiKeyError) {
    title = "Authentication Failed";
    message = "Your Gemini API Key is invalid or expired. Please update it in your profile settings.";
    buttonText = "Update API Key";
    action = () => {
      onClear();
      onNavigate('/profile?tab=api-keys');
    };
  } else if (isQuotaError) {
    title = "Quota Exceeded";
    message = "You have exceeded your API usage quota. Please check your plan or try again later.";
  } else if (errorStatus === '500' || errorStatus === '503') {
    title = "Service Unavailable";
    message = "The AI service is currently unavailable. Please try again in a few days.";
  }

  return (
    <div className="global-error-overlay">
      <div className="global-error-box">
        <div className="global-error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div>
          <h3 className="global-error-title">{title}</h3>
          <p className="global-error-message">
            {message}
            <span className="global-error-code">(Code: {errorStatus})</span>
          </p>
        </div>
        <button
          className="practice-btn primary global-error-btn"
          onClick={action}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default GlobalErrorOverlay;
